// Etichetta "NEW" accanto a una voce di menu: bianco su nero, minuscola, per dare visibilità a una novità.
export function NewBadge() {
  return (
    <span className="ml-1.5 inline-flex h-[15px] items-center rounded-[4px] bg-black px-1 text-[9px] font-semibold uppercase leading-none tracking-wide text-white">
      New
    </span>
  );
}
